module.exports={
    "gestao_AprovacaoRelatorioAprovadosPor": {
        "id": "gestao_AprovacaoRelatorioAprovadosPor",
        "eventName": "RAA_relatorio_aprovado_por",
        "eventProduct": "Gestao",
        "eventCategory": "Acompanhamento de aprovacoes",
        "eventAction": "Selecionar os aprovadores",
        "eventValue": "{{label}}"
    },
    "gestao_AprovacaoRelatorioEnviadosPor": {
        "id": "gestao_AprovacaoRelatorioEnviadosPor",
        "eventName": "RAA_relatorio_enviado_por",
        "eventProduct": "Gestao",
        "eventCategory": "Acompanhamento de aprovacoes",
        "eventAction": "Selecionar usuario que enviou relatorio",
        "eventValue": "{{label}}"
    },
    "gestao_AprovacaoStatusRelatorio": {
        "id": "gestao_AprovacaoStatusRelatorio",
        "eventName": "RAA_selecionar_status_relatorio",
        "eventProduct": "Gestao",
        "eventCategory": "Acompanhamento de aprovacoes",
        "eventAction": "Selecionar o status do relatorio no dropdown",
        "eventValue": "{{label}}"
    },
    "gestao_AprovacaoFluxoAprovacao": {
        "id": "gestao_AprovacaoFluxoAprovacao",
        "eventName": "RAA_selecionar_fluxo_aprovacao",
        "eventProduct": "Gestao",
        "eventCategory": "Acompanhamento de aprovacoes",
        "eventAction": "Selecionar o fluxo de aprovacao no dropdown",
        "eventValue": "{{label}}"
    },
    "gestao_AprovacaoCentroCustos": {
        "id": "gestao_AprovacaoCentroCustos",
        "eventName": "RAA_selecionar_centro_custos",
        "eventProduct": "Gestao",
        "eventCategory": "Acompanhamento de aprovacoes",
        "eventAction": "Selecionar o centro de custos",
        "eventValue": "{{label}}"
    },
    "gestao_AprovacaoDataInicio": {
        "id": "gestao_AprovacaoDataInicio",
        "eventName": "RAA_data_inicio",
        "eventProduct": "Gestao",
        "eventCategory": "Acompanhamento de aprovacoes",
        "eventAction": "Data de início de filtro",
        "eventValue": 0.0
    },
    "gestao_AprovacaoDataFinal": {
        "id": "gestao_AprovacaoDataFinal",
        "eventName": "RAA_data_fim",
        "eventProduct": "Gestao",
        "eventCategory": "Acompanhamento de aprovacoes",
        "eventAction": "Data de término de filtro",
        "eventValue": 0.0
    },
    "gestao_AprovacaoFiltrar": {
        "id": "gestao_AprovacaoFiltrar",
        "eventName": "RAA_filtrar_pesquisa",
        "eventProduct": "Gestao",
        "eventCategory": "Acompanhamento de aprovacoes",
        "eventAction": "Botão para filtrar os dados selecionados",
        "eventValue": 0.0
    },
    "gestao_AprovacaoClickVerRelatorio": {
        "id": "gestao_AprovacaoClickVerRelatorio",
        "eventName": "RAA_click_ver_relatorio",
        "eventProduct": "Gestao",
        "eventCategory": "Acompanhamento de aprovacoes",
        "eventAction": "Clique no botao Ir para Relatório após ser filtrado",
        "eventValue": 0.0
    }
}